<div [appEnforcePermission]="authConfig.investigationReportArchiveCreate"
  #investigationReportArchiveCreate="appEnforcePermission"></div>
<div [appEnforcePermission]="authConfig.investigationReportsSnapshotsDownload"
  #investigationReportsSnapshotsDownload="appEnforcePermission"></div>

<div [dialogRef]="dialog" (appClickOutside)="close()">
  <kendo-dialog-titlebar (close)="close()">
    <div class="modal-title">
      <ng-container *ngIf="report.storedLocation === storedLocation.OneDrive; else s3Title">
        <span>o365 Authentication Required</span>
      </ng-container>
      <ng-template #s3Title>
        <span>Report is archived</span>
      </ng-template>
    </div>
  </kendo-dialog-titlebar>
  <section *ngIf="report.storedLocation === storedLocation.OneDrive else archivedText">
    <p>
      Launching this report will open the document directly in o365. When prompted, please enter the public token shown
      below to confirm your identity within this system.
    </p>

    <h5 class="mb-0" *ngIf="report.storedLocation !== storedLocation.OneDrive">
      <i class="fa-solid fa-lock"></i>
      Your public token:
    </h5>
    <code [innerHTML]="user.msGraphToken"></code>
    <button kendoButton [size]="'medium'" [fillMode]="'link'" [themeColor]="'primary'"
      [iconClass]="'fa-regular fa-copy'" [cdkCopyToClipboard]="user.msGraphToken" class="mb-16">
      Copy to Clipboard
    </button>
    <!-- Hidden iFrame to pass info into Office o365 addin for cookie -->
    <iframe [src]="cookieUrl | domSafe: 'resourceUrl'" width="1" height="1" class="hidden-iframe"></iframe>
  </section>
  <ng-template #archivedText>
    <section>
      <p>
        {{ investigationReportArchiveCreate?.enabled ?
        "This report is currently archived. To edit report in o365, please restore the report back." :
        "This report is currently archived. Please contact NEFCO Admin for further help." }}
      </p>
    </section>
  </ng-template>
  <kendo-dialog-actions layout="end">
    <button *ngIf="report.storedLocation !== storedLocation.OneDrive && investigationReportsSnapshotsDownload?.enabled"
      kendoButton [size]="'medium'" themeColor="light" (click)="downloadExternal()" class="mr-16">
      Download Report
    </button>
    <button *ngIf="report?.Status?.status === IInvestigationReportStatus.Final && investigationReportArchiveCreate?.enabled" kendoButton [size]="'medium'" themeColor="primary" (click)="toggleLocation()"
      [iconClass]="report.storedLocation === storedLocation.OneDrive ? 'fa-solid fa-file-zipper' : 'fa-solid fa-rotate-left'" class="mr-16">
      {{ report.storedLocation === storedLocation.OneDrive ? 'Archive' : 'Restore' }} Report
    </button>
    <button kendoButton *ngIf="report.storedLocation === storedLocation.OneDrive" [size]="'medium'" themeColor="primary"
      (click)="launchReport()" [iconClass]="'fa-regular fa-circle-check'" class="mr-16">
      Open Report
    </button>
  </kendo-dialog-actions>
</div>
